import React, { useMemo, useState } from "react"
import dayjs from "dayjs"
import { Space, DatePicker, Typography } from "antd"
import last from "lodash.last"

const { Text } = Typography
const { RangePicker } = DatePicker

const dateFormat = "MM/DD/YYYY"

const getDateRange = (startDate, endDate) => {
  const start = dayjs(startDate)
  const end = dayjs(endDate)

  return [ start, end ]
}

const getHeaderRenderTitle = updateMonthFilter => {
  const [ value, setValue ] = useState()

  /* eslint-disable-next-line react/display-name */
  return (title, items) => {
    /* eslint-disable-next-line react/destructuring-assignment */
    const shouldSetDateRange = items.length > 0 && !value

    if (shouldSetDateRange) {
      const [ firstItem ] = items
      const lastItem = last(items)

      const { date: endDate } = firstItem
      const { date: startDate } = lastItem

      const newValue = useMemo(() => getDateRange(startDate, endDate), [ startDate, endDate ])
      setValue(newValue)
    }

    const onChange = dateRange => {
      const [ startDate, endDate ] = dateRange
      const newValue = getDateRange(startDate, endDate)
      setValue(newValue)

      return updateMonthFilter(dateRange)
    }

    return (
      <Space size={0}>
        <Text>{title} for</Text>

        <RangePicker
          size="small"
          value={value}
          format={dateFormat}
          style={{ width: 230 }}
          bordered={false}
          onChange={onChange}
          allowClear={false}
          placeholder=""
        />
      </Space>
    )
  }
}

export default getHeaderRenderTitle
